/* eslint-disable no-debugger */
import {
  ADD_COMMAND_TO_UNIT,
  ADD_UNIT,
  CH_UNIT_SELECTED,
  DELETE_UNITS,
  REMOVE_COMMAND_FROM_UNIT,
  SET_UNITS,
  ADD_HLA_UNIT,
  SET_HLA_UNITS,
  SITREP_UNIT_SELECT,
  SITREP_UNIT_DESELECT,
  SITREP_CHANGE_VISUAL_ACTIVE,
  MISREP_COMMAND_SELECT,
  MISREP_COMMAND_DESELECT,
  MISREP_UNIT_SELECT,
  MISREP_UNIT_DESELECT,
  UPDATE_UNITS_FROM_BACKEND,
  TOGGLE_MISREP_UNIT_UNVISIBLE,
  TOGGLE_SITREP_UNIT_UNVISIBLE,
  TOGGLE_SITREP_DOCK,
  TOGGLE_MISREP_DOCK,
  CHANGE_SITREP_POSITION,
  CHANGE_MISREP_POSITION,
  COMMAND_QUEUE_UNIT_SELECT,
  COMMAND_QUEUE_UNIT_DESELECT,
  TOGGLE_COMMAND_QUEUE_DOCK,
  CHANGE_COMMAND_QUEUE_POSITION,
  COMMAND_QUEUE_COMMAND_SELECT,
  COMMAND_QUEUE_COMMAND_DESELECT,
  RESET_SITREP_SELECTED_UNITS,
  RESET_MISREP_SELECTED_UNITS,
  RESET_COMMAND_QUEUE_SELECTED_UNITS,
  SET_LAST_ACTIVE_BAR,
  CHANGE_WEIGHT_UNIT,
  FILTER_UNITS,
  SIDES_ADDED,
  FACTIONS_ADDED,
  PROTOTYPES_ADDED,
  OBSTACLES_ADDED,
  SET_HLA_MAP_UNITS,
} from 'src/app/redux/redux-types';
import {
  CombinedEtmenAndCevreselEtmenGuncellemeType,
  EMesajAltTipi,
  EtmenGuncellemeType,
  OlayType,
} from 'src/types/components/socket.type';
// import { MapUnit } from 'src/types/components/unit.type';
import { TBarPosition } from 'src/types/mixed.type';
import { SitrepChangeVisualActive, TUpdateUnitsFromBackend } from 'src/types/redux/hymotsc/units.redux.type';
import { EtmenSiniflariResultType } from 'src/types/services/hymotsc/etmen-siniflari.type';
import { EtmenTurleriResultType } from 'src/types/services/hymotsc/etmen-turleri.type';
import { InsanYapimiEngelTuruResultType } from 'src/types/services/hymotsc/insan-yapimi-engel-turu.type';
import { TaraflarResultType } from 'src/types/services/hymotsc/taraflar.type';
import { EtmenTuruGuncellemeType, MapUnit, HlaMapUnit, UnitType, HLAUnit } from 'src/types/unit.type';

export const updateUnitsFromBackend = (
  responseUnits: CombinedEtmenAndCevreselEtmenGuncellemeType[],
  mesajAltTipi?: EMesajAltTipi,
  olaylar?: string,
  prototypes?: EtmenTuruGuncellemeType[],
) => {
  return {
    type: UPDATE_UNITS_FROM_BACKEND,
    payload: {
      etmenGuncelleme: responseUnits,
      mesajAltTipi,
      olaylar,
      prototypes,
    } as TUpdateUnitsFromBackend,
  };
};

export const setUnits = (units: MapUnit[]) => {
  return {
    type: SET_UNITS,
    payload: units,
  };
};

export const setHlaMapUnits = (units: HlaMapUnit[]) => {
  return {
    type: SET_HLA_MAP_UNITS,
    payload: units,
  };
};

export const addHlaUnit = (unit: HLAUnit) => {
  return {
    type: ADD_HLA_UNIT,
    payload: unit,
  };
};

export const setHlaUnits = (units: HLAUnit[]) => {
  return {
    type: SET_HLA_UNITS,
    payload: units,
  };
};

export const addUnit = (unit: MapUnit | undefined) => {
  return {
    type: ADD_UNIT,
    payload: unit,
  };
};

export const deleteUnits = (ids: number[] | undefined) => {
  return {
    type: DELETE_UNITS,
    payload: ids,
  };
};

export const sitrepSelectUnit = (unitId: number | bigint, unitType: UnitType) => {
  return {
    type: SITREP_UNIT_SELECT,
    payload: {
      unitId,
      unitType,
    },
  };
};

export const sitrepDeselectUnit = (unitId: number) => {
  return {
    type: SITREP_UNIT_DESELECT,
    payload: unitId,
  };
};

export const chSelectUnit = (unitId: number | undefined) => {
  return {
    type: CH_UNIT_SELECTED,
    payload: unitId,
  };
};

// export const addCommand = (data: TUnitAddRemoveCommand) => {
//   return {
//     type: ADD_COMMAND_TO_UNIT,
//     payload: data,
//   };
// };

// export const removeCommand = (data: TUnitAddRemoveCommand) => {
//   return {
//     type: REMOVE_COMMAND_FROM_UNIT,
//     payload: data,
//   };
// };

export const sitrepChangeVisualActive = (data: SitrepChangeVisualActive) => {
  return {
    type: SITREP_CHANGE_VISUAL_ACTIVE,
    payload: data,
  };
};

export const misrepCommandSelect = (commandId: number) => {
  return {
    type: MISREP_COMMAND_SELECT,
    payload: commandId,
  };
};

export const misrepCommandDeselect = (commandId: number) => {
  return {
    type: MISREP_COMMAND_DESELECT,
    payload: commandId,
  };
};
export const commandQueueCommandSelect = (commandId: number) => {
  return {
    type: COMMAND_QUEUE_COMMAND_SELECT,
    payload: commandId,
  };
};

export const commandQueueCommandDeselect = () => {
  return {
    type: COMMAND_QUEUE_COMMAND_DESELECT,
  };
};

export const misrepSelectUnit = (unitId: number) => {
  return {
    type: MISREP_UNIT_SELECT,
    payload: unitId,
  };
};

export const misrepDeselectUnit = (unitId: number) => {
  return {
    type: MISREP_UNIT_DESELECT,
    payload: unitId,
  };
};

export const toggleSitrepUnitUnvisible = (unitId: number) => {
  return {
    type: TOGGLE_SITREP_UNIT_UNVISIBLE,
    payload: unitId,
  };
};

export const toggleMisrepUnitUnvisible = (unitId: number) => {
  return {
    type: TOGGLE_MISREP_UNIT_UNVISIBLE,
    payload: unitId,
  };
};

export const toggleSitrepDock = (unitId: number) => {
  return {
    type: TOGGLE_SITREP_DOCK,
    payload: unitId,
  };
};

export const toggleMisrepDock = (unitId: number) => {
  return {
    type: TOGGLE_MISREP_DOCK,
    payload: unitId,
  };
};

export const toggleCommandQueueDock = (unitId: number) => {
  return {
    type: TOGGLE_COMMAND_QUEUE_DOCK,
    payload: unitId,
  };
};

export const changeSitrepPosition = (id: number, position: TBarPosition) => {
  return {
    type: CHANGE_SITREP_POSITION,
    payload: { id, position },
  };
};

export const changeMisrepPosition = (id: number, position: TBarPosition) => {
  return {
    type: CHANGE_MISREP_POSITION,
    payload: { id, position },
  };
};

export const changeCommandQueuePosition = (id: number, position: TBarPosition) => {
  return {
    type: CHANGE_COMMAND_QUEUE_POSITION,
    payload: { id, position },
  };
};

export const commandQueueSelectUnit = (unitId: number) => {
  return {
    type: COMMAND_QUEUE_UNIT_SELECT,
    payload: unitId,
  };
};

export const commandQueueDeselectUnit = (unitId: number) => {
  return {
    type: COMMAND_QUEUE_UNIT_DESELECT,
    payload: unitId,
  };
};

export const resetSitrepSelectedUnits = () => {
  return {
    type: RESET_SITREP_SELECTED_UNITS,
  };
};

export const resetMisrepSelectedUnits = () => {
  return {
    type: RESET_MISREP_SELECTED_UNITS,
  };
};

export const resetCommandQueueSelectedUnits = () => {
  return {
    type: RESET_COMMAND_QUEUE_SELECTED_UNITS,
  };
};

export const setLastActiveBar = (id: number, type: 'misrep' | 'sitrep' | 'commandQueue') => {
  return {
    type: SET_LAST_ACTIVE_BAR,
    payload: {
      id,
      type,
    },
  };
};

export const changeWeightUnit = (payload: number) => {
  return {
    type: CHANGE_WEIGHT_UNIT,
    payload,
  };
};

export const filterUnits = (payload: number[]) => {
  return {
    type: FILTER_UNITS,
    payload,
  };
};

export const setSides = (payload: TaraflarResultType[]) => {
  return {
    type: SIDES_ADDED,
    payload,
  };
};

export const setFactions = (payload: EtmenSiniflariResultType[]) => {
  return {
    type: FACTIONS_ADDED,
    payload,
  };
};

export const setPrototypes = (payload: EtmenTurleriResultType[]) => {
  return {
    type: PROTOTYPES_ADDED,
    payload,
  };
};

export const setObstacles = (payload: InsanYapimiEngelTuruResultType[]) => {
  return {
    type: OBSTACLES_ADDED,
    payload,
  };
};
